import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
import InputField from '../../utils/InputMUI'

import { saveUpdateAddressApi, getZipBranchDetailApi, getAddressDetailCommunityApi } from './DealerActioncreator'




export default function BasicDetails({ handlePage, handleTabs, communityId, Detaildata }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [ObjectData, setObjectData] = useState({
        address: '',
        area: '',
        pincode: '',
        state: '',
        city: '',
        latitude: 0,
        longitude: 0,

    })

    const validateForm = () => {
    let newErrors = {};

    if (!ObjectData.address?.trim()) newErrors.address = "Address is required";
    if (!ObjectData.area?.trim()) newErrors.area = "Area is required";

    // if (!ObjectData.pincode?.trim()) {
    //     newErrors.pincode = "Pincode is required";
    // } else if (!/^[1-9][0-9]{5}$/.test(ObjectData.pincode)) {
    //     newErrors.pincode = "Enter a valid 6-digit pincode";
    // }

    if (!ObjectData.state?.trim()) newErrors.state = "State is required";
    if (!ObjectData.city?.trim()) newErrors.city = "City is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; 
};


     useEffect(()=>{
            if(Detaildata?.rowData?.communityId){
                setloaderState(true)
                getAddressDetailCommunityApi(Detaildata?.rowData?.communityId,(callback)=>{
                    console.log("Detaildata?.communityId",callback)
                    if(callback && callback?.length > 0){
                        setObjectData({
                            address: callback?.[0]?.address || '',
                            area: callback?.[0]?.area || '',
                            pincode: callback?.[0]?.pincode || '',
                            state: callback?.[0]?.state || '',
                            city: callback?.[0]?.city || '',
                            latitude: callback?.[0]?.latitude || 0,
                            longitude: callback?.[0]?.longitude || 0,
                        })
                    }else{
                        setObjectData({
                            address: '',
                            area: '',
                            pincode: '',
                            state: '',
                            city: '',
                            latitude: 0,
                            longitude: 0,
                        })
                    }
                    setloaderState(false)
                })
            }
        },[Detaildata?.rowData])


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)


        if ((type === 'pincode') && changeObjectData[type].length === 5) {
            console.log(type,changeObjectData,e)
            const data = {
                code: e,
                type: 'zip'
            }
            setloaderState(true)
            getZipBranchDetailApi(data, callBack => {
                if (callBack.status === 'success') {
                    let changeObjectData = Object.assign({}, ObjectData)
                    changeObjectData[type] = e
                    if (type === 'pincode') {
                        changeObjectData.city = callBack.destrict
                        changeObjectData.state = callBack.state



                    }

                    setloaderState(false)

                    setObjectData(changeObjectData)
                } else {
                    setloaderState(false)

                    alert('Please enter correct pincode')
                }
            }, error => {

            })

        } else {
            changeObjectData[type] = e
        }

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            if (!validateForm()) return;
            setloaderState(true)
            const obj = { ...ObjectData, communityId: communityId }
            saveUpdateAddressApi(obj, (callback) => {
                setloaderState(false)
                handleTabs("bank")
            })
        } else if (e === 'close') {
            handlePage("", "list")
        }
    }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={Detaildata?.rowData?.communityId ? 4 :5}
                    currentPage={2}
                    heading={'Add Address Info'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Address Line"
                            variant="outlined"
                            value={ObjectData.address}
                            name="address"
                            id="address"
                            type="text"
                            onChange={e => inputChange(e, 'address')}
                            size="small"
                        required={true}
                        />
                        {errors.address && <div className="form-text text-danger" style={{fontSize:"10px"}}>{errors.address}</div>}
                        {/* {
                            errors?.address &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.address}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Area"
                            variant="outlined"
                            value={ObjectData.area}
                            name="area"
                            id="area"
                            type="text"
                            onChange={e => inputChange(e, 'area')}
                            size="small" required={true}

                        />
                         {errors.area && <div className="form-text text-danger" style={{fontSize:"10px"}}>{errors.area}</div>}
                        {/* {
                        {/* {
                            errors?.area &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.area}</div>
                        } */}


                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Pincode"
                            variant="outlined"
                            value={ObjectData.pincode}
                            name="pincode"
                            id="pincode"
                            type="number"
                            onChange={e => inputChange(e, 'pincode')}
                            size="small" required={true}

                        />
                           {errors.pincode && <div className="form-text text-danger" style={{fontSize:"10px"}}>{errors.pincode}</div>}
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="State"
                            variant="outlined"
                            value={ObjectData.state}
                            name="state"
                            id="state"
                            type="text"
                            onChange={e => inputChange(e, 'state')}
                            size="small" required={true}

                        />
                          {errors.state && <div className="form-text text-danger" style={{fontSize:"10px"}}>{errors.state}</div>}
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="City"
                            variant="outlined"
                            value={ObjectData.city}
                            name="city"
                            id="city"
                            type="text"
                            onChange={e => inputChange(e, 'city')}
                            size="small"
                            required={true}

                        />
                          {errors.city && <div className="form-text text-danger" style={{fontSize:"10px"}}>{errors.city}</div>}
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>
                    {/* <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Latitude"
                            variant="outlined"
                            value={ObjectData.latitude}
                            name="latitude"
                            id="latitude"
                            type="number"
                            onChange={e => inputChange(e, 'latitude')}
                            size="small"

                        />
                        

                    </div> */}

                </div>
                {/* <div className="row">

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Longitude"
                            variant="outlined"
                            value={ObjectData.longitude}
                            name="longitude"
                            id="longitude"
                            type="number"
                            onChange={e => inputChange(e, 'longitude')}
                            size="small"

                        />
                        

                    </div>

                </div> */}


                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger" style={{fontSize:"10px"}}>{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save and Continue</button>
                    </div>
                </div>
            </div>
        </>
    )
}
